import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Stick from '../../../es';
import Regression from './Regression';
const Anchor = ({ width, children }) => (_jsx("div", { style: {
        height: 18,
        color: 'white',
        width,
        backgroundColor: 'rgb(24, 170, 177)',
    }, children: children }));
const Node = ({ children }) => (_jsx("div", { style: {
        backgroundColor: '#ae0d5c',
        color: 'white',
        minHeight: 18,
    }, children: children }));
export default function SameWidth() {
    return (_jsx(Regression, { allBrowsers: true, fixed: true, title: "Same width", description: "Stick node must have the same width as the anchor element, if `sameWidth` prop is set", children: _jsxs("div", { style: {
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'center',
                height: 200,
                marginRight: 250,
            }, children: [_jsx(Stick, { sameWidth: true, position: "bottom center", node: _jsx(Node, {}), children: _jsx(Anchor, { children: "The stick node below should have the same width" }) }), _jsx(Stick, { sameWidth: true, inline: true, position: "bottom center", node: _jsx(Node, {}), children: _jsx(Anchor, { children: "The inline stick node below should have the same width" }) }), _jsx(Stick, { position: "bottom center", sameWidth: true, node: _jsx(Node, { children: "This text should break to respect the anchor's width" }), children: _jsx(Anchor, { width: 100 }) })] }) }));
}
